import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numbertostring'
})
export class NumberToStringPipe implements PipeTransform {
    transform(money: number): any {
        const threeDigitsToLetter = (num) => {
            var letterOfnum = [' không ', ' một ', ' hai ', ' ba ', ' bốn ', ' năm ', ' sáu ', ' bảy ', ' tám ', ' chín '];
            let tram, chuc, donvi, _result = '';
            tram = Math.floor(num / 100);
            chuc = Math.floor(num % 100 / 10);
            donvi = num % 10;
            if (tram == 0 && chuc == 0 && donvi == 0) return '';
            if (tram != 0) {
                _result += letterOfnum[tram] + 'trăm ';
                if ((chuc == 0) && (donvi != 0)) _result += 'linh';
            }
            if ((chuc != 0) && (chuc != 1)) {
                _result += letterOfnum[chuc] + 'mươi ';
                if ((chuc == 0) && (donvi != 0)) _result = _result + 'linh';
            }
            if (chuc == 1) _result += 'mười';
            switch (donvi) {
                case 1:
                    if ((chuc != 0) && (chuc != 1)) {
                        _result += 'mốt';
                    }
                    else {
                        _result += letterOfnum[donvi];
                    }
                    break;
                case 5:
                    if (chuc == 0) {
                        _result += letterOfnum[donvi];
                    }
                    else {
                        _result += ' lăm';
                    }
                    break;
                default:
                    if (donvi != 0) {
                        _result += letterOfnum[donvi];
                    }
                    break;
            }
            return _result;
        };
        if (money && (money % 1 === 0)) {
            var count = 0, i = 0, num = money, _result = '';
            var tmp;
            var locate = new Array();
            var unitOfnum = ['', 'nghìn', 'triệu', 'tỷ', 'nghìn tỷ', 'triệu tỷ'];
            locate[5] = Math.floor(num / 1000000000000000);
            if (isNaN(locate[5]))
                locate[5] = '0';
            num = num - parseFloat(locate[5].toString()) * 1000000000000000;
            locate[4] = Math.floor(num / 1000000000000);
            if (isNaN(locate[4]))
                locate[4] = '0';
            num = num - parseFloat(locate[4].toString()) * 1000000000000;
            locate[3] = Math.floor(num / 1000000000);
            if (isNaN(locate[3]))
                locate[3] = '0';
            num = num - parseFloat(locate[3].toString()) * 1000000000;
            locate[2] = Math.floor(num / 1000000);
            if (isNaN(locate[2]))
                locate[2] = '0';
            locate[1] = Math.floor((num % 1000000) / 1000);
            if (isNaN(locate[1]))
                locate[1] = '0';
            locate[0] = Math.floor(num % 1000);
            if (isNaN(locate[0]))
                locate[0] = '0';
            if (locate[5] > 0) {
                count = 5;
            }
            else if (locate[4] > 0) {
                count = 4;
            }
            else if (locate[3] > 0) {
                count = 3;
            }
            else if (locate[2] > 0) {
                count = 2;
            }
            else if (locate[1] > 0) {
                count = 1;
            }
            else {
                count = 0;
            }
            for (i = count; i >= 0; i--) {
                tmp = threeDigitsToLetter(locate[i]);
                _result += ' ' + tmp.trim();
                if (locate[i] > 0) _result += ' ' + unitOfnum[i];
            }
            _result = _result.substring(1, 2).toUpperCase() + _result.substring(2);
            if (_result !== '') {
                return _result.trim() + ' đồng';
            } else {
                return '';
            }
        }
        return money;
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/ConvertMoneyToString/numberToString.pipe.ts